// @ts-ignore
// @ts-nocheck
import { toast } from 'react-toastify';
import api from 'services/api';

const getAccessToken = () => {
  return localStorage.getItem('@UltragazEmpresarial:accessToken');
};

export const getContracts = async (siteId) => {
  const access_token = getAccessToken();

  try {
    const responseContracts = await api.get(
      `industrial/customer/v1/customers/me/contracts?site-id=${siteId}&type=CONTRACT`,
      {
        headers: {
          access_token,
          client_id: process.env.REACT_APP_CLIENT_ID,
        },
      }
    );

    if (responseContracts.status === 200) {
      return responseContracts.data;
    }

    return null;
  } catch {
    const msgError = `Ops! Parece que algo deu errado. Sugerimos que você converse com a Ully, a nossa assistente virtual, e esclareça  a sua solicitação.`;
    toast.error(msgError);
  }
};

export const getDownloadContracts = async ({
  deliveryMethod,
  siteId,
  contactIdSf,
  contractNumber,
  beginDate,
  endDate,
  documentName,
  attachmentId,
  email = '',
}) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const emails = [];

  if (email) {
    emails.push({ email });
  }

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    siteId,
    deliveryMethod,
    beginDate,
    endDate,
    contractNumber,
    contactIdSf: contactIdSf !== 'undefined' ? contactIdSf : '',
    emails,
  };

  try {
    const responseDocument = await api.post(
      `/industrial/customer/v1/customers/me/contracts/${attachmentId}`,
      body,
      parameters
    );

    if (responseDocument.status === 200) {
      const { base64 } = responseDocument.data;
      const byteString = window.atob(base64);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i += 1) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      if (deliveryMethod === 'DOWNLOAD') {
        const url = window.URL.createObjectURL(
          new Blob([int8Array], { type: 'application/pdf' })
        );
        const linkDownload = document.createElement('a');
        linkDownload.href = url;
        linkDownload.setAttribute('download', `${documentName}.pdf`);
        document.body.appendChild(linkDownload);
        linkDownload.click();
        linkDownload.parentNode.removeChild(linkDownload);
        return responseDocument;
      }
      return responseDocument;
    }
    if (responseDocument.status === 204) {
      return responseDocument;
    }
  } catch (error) {
    toast.error('Ocorreu um erro ao solicitar o contrato, tente novamente!');
  }
};

export const getSecondContract = async () => {
  const access_token = await getAccessToken();

  const customerSiteIdStorage = await localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const contactIdSfStorage = await localStorage.removeItem(
    '@UltragazEmpresarial:contactIdSf'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    customerSiteId:
      customerSiteIdStorage !== 'undefined' ? customerSiteIdStorage : '',
    contactIdSf: contactIdSfStorage !== 'undefined' ? contactIdSfStorage : '',
  };

  try {
    const responseDocument = await api.post(
      'industrial/case/v1/cases-sf/contract-request',
      body,
      parameters
    );

    if (responseDocument.status === 201) {
      return responseDocument.data;
    }
    return [];
  } catch (error) {
    const message =
      error?.response?.data[0]?.message ||
      'Ocorreu um erro ao solicitar o contrato, tente novamente!';
    toast.error(message);
  }
};
